import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CustomLocaleModule } from '@onclass/oc-custom-locale';

@NgModule({
  imports: [CommonModule, CustomLocaleModule],
  exports: [CustomLocaleModule],
})
export class LocaleSharedModule {}
